/**
 * @generated SignedSource<<81077a34bf6aaca7e2b92aeb8d7df9d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WSEmployeeScheduleQuery$variables = {
  id: string;
};
export type WSEmployeeScheduleQuery$data = {
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleSettingsQuery_store">;
  };
  readonly widgetEmployeeSchedule: {
    readonly id: string;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type WSEmployeeScheduleQuery = {
  response: WSEmployeeScheduleQuery$data;
  variables: WSEmployeeScheduleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "WidgetEmployeeSchedule",
  "kind": "LinkedField",
  "name": "widgetEmployeeSchedule",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSEmployeeScheduleQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetEmployeeScheduleSettingsQuery_store"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSEmployeeScheduleQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myRole",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeScheduleType",
            "kind": "LinkedField",
            "name": "employeeScheduleTypes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "assignedTeams",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "885a308b5732a2d10ed5f7b155b51098",
    "id": null,
    "metadata": {},
    "name": "WSEmployeeScheduleQuery",
    "operationKind": "query",
    "text": "query WSEmployeeScheduleQuery(\n  $id: ID!\n) {\n  widgetEmployeeSchedule(id: $id) {\n    id\n    teams {\n      id\n    }\n  }\n  store {\n    ...WidgetEmployeeScheduleSettingsQuery_store\n    id\n  }\n}\n\nfragment ManageEmployeeSchedueTypesListItem_store on Store {\n  employeeScheduleTypes {\n    id\n    assignedTeams {\n      id\n    }\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetEmployeeScheduleSettingsQuery_store on Store {\n  myRole\n  publicTeams {\n    ...TeamSelectList_Team\n    id\n  }\n  ...ManageEmployeeSchedueTypesListItem_store\n}\n"
  }
};
})();

(node as any).hash = "79042970e359faa3fe8cde90ac437df0";

export default node;
